( function( $ ) {
  /* Sticky Header */
  if ( $(window).scrollTop() <= 50 ) {
    $( 'header' ).removeClass( '__sticky' );
  } else {
    $( 'header' ).addClass( '__sticky' );
  }
  $( window ).scroll( function() {
    if ( $(window).scrollTop() <= 50 ) {
      $( 'header' ).removeClass( '__sticky' );
    } else {
      $( 'header' ).addClass( '__sticky' );
    }
  } );
  
  /* Mobile Menu */
  $( document ).on( 'click touchstart', '.hamburger', function() {
    if( $( this ).hasClass( 'is-active' ) ) {
      $( this ).removeClass( 'is-active' );
    } else {
      $( this ).addClass( 'is-active' );
    }
  } );
  
  /* Add show submenu in mobile menu */
  $( document ).on( 'click', '.dp-plain-menu > li > a', function( e ) {
    var link_container = $( this ).parent();

    if( ! link_container.hasClass( '__external_link' ) ) {
      e.preventDefault();

      var _this = $( this );

      $( '.dp-plain-menu > li > a' ).removeClass( '__active' );
      _this.addClass( '__active' );

      var parent_li = _this.parent();

      $( '.second-level-menu' ).slideUp();

      if ( $( 'ul', parent_li ).is(':visible') ) {
        $( 'ul', parent_li ).slideUp( function() {
          _this.removeClass( '__active' );
        } );
      } else {
        $( 'ul', parent_li ).slideDown(); 
      }
    }
  } );
  
  /* Initiate sidr function to enable mobile menu */
  $( '.hamburger' ).sidr( {
    name: 'main-menu',
    side: 'left',
  } );

  /* Header Dropdown */
  var header_dp;
  if( $( window ).width() <= 750 ) {
    header_dp = $( '.__header_dropdown' ).html();
    if( header_dp != undefined ) {
      $( '.__header_dropdown' ).remove();
      $( '#main-menu' ).append( '<div class="__header_dropdown_mobile">' + header_dp + '</div>' );
    }
  }
  $( window ).on( 'resize', function() {
    if( $( window ).width() <= 750 ) {
      header_dp = $( '.__header_dropdown' ).html();
      if( header_dp != undefined ) {
        $( '.__header_dropdown' ).remove();
        $( '#main-menu' ).append( '<div class="__header_dropdown_mobile">' + header_dp + '</div>' );
      }
    } else {
      header_dp = $( '.__header_dropdown_mobile' ).html();
      if ( header_dp != undefined ) {
        $( '.__header_dropdown_mobile' ).remove();  
        $( '.__menu_bar .column' ).append( '<div class="__header_dropdown">' + header_dp + '</div>' );
      }
    }
  } );

  /* Venue Dropdown */
  $( document ).on( 'change', 'select[name="select_venue"]', function() {
    var link = $( this ).val();
    var target = $('option:selected', this).attr( 'data-target' );
    if( link != '' ) {
      if( target == '_blank' ) {
        window.open( link );
      } else {
        window.location = link;
      }
    }
  } );
} ) ( jQuery );